<div class="p-3 fs-3 card text-bg-dark d-flex-column gap-3">
  <div class="d-flex-row gap-2">
    <button type="button"
      class="btn btn-primary"
      (click)="cacheReset()"
    >Cache Reset</button>

    <button type="button"
      class="btn btn-danger"
      (click)="fullReset()"
    >Full Reset</button>

    <button type="button"
      class="btn btn-secondary"
      (click)="retry()"
    >Retry</button>
  </div>

  Please take a picture of this error information and send it to dan.drew&#64;hotmail.com
</div>

@for ($error of errors; track $error) {
  <div style="user-select: text !important;">
    <table class="table table-bordered border-dark-subtle">
      <tr>
        <th>Time</th>
        <td>{{ $error.time | date:'medium' }}</td>
      </tr>
      <tr>
        <th>Message</th>
        <td><pre>{{ $error.message }}</pre></td>
      </tr>
      @if ($error.file) {
        <tr>
          <th>Location</th>
          <td>{{ $error.file }}@if ($error.line) {
            :{{ $error.line }}
          }</td>
        </tr>
      }
      @if ($error.stack) {
        <tr>
          <th>Stack</th>
          <td>
            <pre>{{ $error.stack.join("\n") }}</pre>
          </td>
        </tr>
      }
    </table>
  </div>
}
